
<template>
  <!--新增话题-->
  <x-addEdit
    apiOrigin="PHP"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit],
  name: 'addTopic',
  data () {
    return {
      formList: [
        {
          label: '话题名',
          inputType: 'input',
          options: [],
          placeholder: '请输入话题名',
          props: ['title', {
            rules: [
              { pattern: this.REG.unSpecialChar, message: this.MESSAGE.unSpecialChar },
              { min: 1, max: 20, message: '栏目名不超过20个字' },
              { required: true, message: '请输入话题名' }
            ]
          }]
        },
        {
          label: '所属栏目',
          inputType: 'select',
          options: [],
          placeholder: '所属栏目',
          props: ['columns_id', {
            rules: [{ required: true, message: '请选择所属栏目' }]
          }]
        }
      ],
      formKey: {
        title: undefined,
        columns_id: undefined
      },
      addParam: {
        url: '/circle/topics',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/circle/topics/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/circle/topics/',
        resHandle: '' // this.resHandle
      }
    };
  },
  computed: {
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/circle/topics/selectlist',
        params: {}
      }).then(({data}) => {
        this.formList[1].options = data.columns;
      });
    },
    resHandle (res) {
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
